import { mdiCrosshairsGps } from '@mdi/js';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';
import Button from 'client/components/aria/Button/Button';
import { ProgressCircle } from 'client/components/aria/Loading';
import { setTrackLocation } from 'client/store/mapSlice/mapSlice';

export const MyLocationButton = ({ onPress, className, labelI18nKey }) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const trackLocation = useSelector(state => state.map?.trackLocation);
    const gotGeoLocationResult = useSelector(state => state.map?.gotGeoLocationResult);
    const loading = trackLocation && !gotGeoLocationResult;

    const moveToMyLocation = () => {
        dispatch(setTrackLocation(true));
        onPress();
    };

    return <Button
        onPress={moveToMyLocation}
        data-testid={'myLocationButton.button'}
        className={className}
        variant='secondary'
        aria-label={intl.formatMessage({ id: labelI18nKey })}
        isDisabled={loading}
    >
        {loading
            ? <ProgressCircle
                data-testid={'myLocationButton.loading'}
                className={className}
                isIndeterminate
                size={24}
            />
            : <Icon path={mdiCrosshairsGps} data-testid={'myLocationButton.icon'} />
        }
    </Button>;
};

MyLocationButton.propTypes = {
    onPress: PropTypes.func,
    className: PropTypes.string,
    labelI18nKey: PropTypes.string
};

MyLocationButton.defaultProps = {
    onPress: () => {},
    className: '',
    labelI18nKey: 'myLocationButton.findMe'
};

export default MyLocationButton;
